import * as React from 'react';
import {
  IMetricSettings,
  metricSettings,
} from '../../../data/providers/settings/metricSettingsProvider';
import { setImperialMetricSetting } from '../../../data/writers/settings';
import { ControlSpacer } from '../../shared/form/ControlSpacer';
import { SelectBox } from '../../shared/form/SelectBox';

/**
 * @description toggle for the users imperial setting
 * @param props
 */
const ImperialSetting = (): React.ReactElement => {
  const [imperial, setImperial] = React.useState<boolean>(false);

  /**
   * @description subsribe to imperial settings
   */
  React.useEffect((): (() => void) => {
    const settingsSubscriber = metricSettings.subscribe(
      (settings: IMetricSettings): void => {
        setImperial(Boolean(settings?.imperial));
      }
    );
    return (): void => {
      settingsSubscriber.unsubscribe();
    };
  });

  /**
   * @description handle imperial setting change
   */
  const onImperialSettingChange = (): Promise<void> =>
    setImperialMetricSetting(!imperial);

  return (
    <ControlSpacer style={{ alignSelf: 'flex-start' }}>
      <SelectBox
        onSelect={onImperialSettingChange}
        selected={imperial}
        label='Use Imperial units'
      />
    </ControlSpacer>
  );
};

export { ImperialSetting };
